import axios from '@axios'

export default {
    namespaced: true,
    state: {
      relojes: [],
    },
    getters: {
      getRelojes: state => state.relojes,
    },
    mutations: {
      SET_RELOJES(state, relojes) {
        state.relojes = relojes;
      },
    },
    actions: {
      fetchRelojUsuario({}) {
        return new Promise((resolve, reject) => {
          axios.get("/api/auth/controlTicket/relojUsuario", { params: { ttl: 0 } })
            .then( response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },

      fetchRelojes({ commit }) {
        return new Promise((resolve, reject) => {
          axios.get("/api/auth/controlTicket/relojes")
            .then( response => {
              commit('SET_RELOJES', response.data);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },

      fetchConectarReloj({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(import.meta.env.VITE_NET_WEB_API_URL+'api/a19402/conectarReloj', data)
            .then( response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },

      fetchDesconectarReloj({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(import.meta.env.VITE_NET_WEB_API_URL+'api/a19402/desconectarReloj', data)
            .then( response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },
        
      fetchImprimirTicket({ commit }, data) {
        return new Promise((resolve, reject) => {
          axios.post(import.meta.env.VITE_NET_WEB_API_URL+'api/Marcacion/marcacionesComedor', data)
          // axios({
          //   method: 'body',
          //   url: 'http://10.51.16.243:5164/api/Marcacion/marcacionesComedor',
          //   responseType: 'stream',
          //   headers: {
          //     'Origin': 'http://10.51.16.243/'
          //   },
          // })
            .then( response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },

      // Configuracion
      fetchRelojesUsuarios({}) {
        return new Promise((resolve, reject) => {
          axios.get("/api/auth/controlTicket/relojesUsuarios")
            .then( response => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            })
        })
      },
    }
}